export default class BaseEntity {
  id = 0;
}
